export default "__VITE_ASSET__BN93m$pB__"